var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badges-container"},[(_vm.channels && _vm.channels.length)?_vm._l((_vm.channels),function(channel){return _c('span',{key:channel,class:['channel-badge', _vm.getChannelClass(channel)]},[_vm._v(" "+_vm._s(channel)+" ")])}):_c('span',{staticClass:"empty-value"},[_vm._v("-")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }